// removed by extract-text-webpack-plugin
module.exports = {"pharmacyTemplate":"_18Ei6a3g6L30GFZI_wXiuI","header":"_2OZ49SHuIQM2zritrZdWN-","pageContainer":"V_zWL0n2_Csfa6kf91SK_","sidebar":"_2uXFh5yJwx4XqDo0iz3Ggk","content":"OtV5hR1L8gAZwM5EOj-B_"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PharmacyTemplate.scss
// module id = 573
// module chunks = 0